import axios from "axios";
import toQueryString from "../common/utils/to-query-string";

const getOnboardingsSimple = (query) => axios.get(toQueryString("api/v1/task-survey-managements/simple?", query));

const getScenarios = (query) => axios.get(toQueryString("api/v1/task-survey-managements?", query));

const getScenarioById = (id) =>
  axios.get(`api/v1/task-survey-managements/${id}`);

const deleteScenario = (id) =>
  axios.delete(`api/v1/task-survey-managements/${id}`);

const updateScenario = (id, params) =>
  axios.put(`api/v1/task-survey-managements/${id}`, params);

const updateScenarioVersion = (scenarioVersionId, params) =>
  axios.put(
    `api/v1/task-survey-managements/version/${scenarioVersionId}`,
    params
  );

const createScenario = () => axios.post("api/v1/task-survey-managements");

const activateScenario = (versionId) =>
  axios.put(
    `api/v1/task-survey-managements/version/${versionId}/activate`
  );

const discardScenarioChanges = (versionId) =>
  axios.put(
    `api/v1/task-survey-managements/version/${versionId}/discard`
  );

const duplicateScenario = (scenarioId) =>
  axios.post(`api/v1/task-survey-managements/${scenarioId}/duplicate`);

const getAlternativeMessages = (originalMessage, alreadyGeneratedMessages) =>
  axios.post(`api/v1/scenario-managements/alternative-messages`, {
    originalMessage,
    alreadyGeneratedMessages,
  });

const getAllMessages = async () => {
  const response = (await axios.get(`api/v1/scenario-managements/all-messages`))
    .data;

  return {
    data: response.data,
  };
};

const ApiSurveyTaskManagement = {
  getScenarios,
  getScenarioById,
  deleteScenario,
  updateScenario,
  updateScenarioVersion,
  createScenario,
  activateScenario,
  discardScenarioChanges,
  duplicateScenario,
  getOnboardingsSimple,
  getAlternativeMessages,
  getAllMessages
};

export default ApiSurveyTaskManagement;
